export type MentionPart = { text: string; username?: string }

// Keep addresses, URL paths and embedded @ signs as ordinary text.
const boundary = '[\\s([{"\'“‘]'

export function mentionAtCaret(text: string, start: number, end = start) {
  if (start !== end) return null
  const match = text
    .slice(0, start)
    .match(new RegExp(`(?:^|${boundary})@([\\w-]{0,30})$`))
  if (!match) return null
  return { from: start - match[1].length - 1, query: match[1] }
}

export function mentionParts(text: string): MentionPart[] {
  const pattern = new RegExp(`(^|${boundary})@([\\w-]{3,30})(?![\\w-])`, 'g')
  const parts: MentionPart[] = []
  let cursor = 0
  for (const match of text.matchAll(pattern)) {
    const start = match.index! + match[1].length
    if (start > cursor) parts.push({ text: text.slice(cursor, start) })
    parts.push({ text: `@${match[2]}`, username: match[2] })
    cursor = start + match[2].length + 1
  }
  if (cursor < text.length) parts.push({ text: text.slice(cursor) })
  return parts
}
